export default {
  // Options.jsx
  items_per_page: '/ stronę',
  jump_to: 'Idź do',
  jump_to_confirm: 'potwierdzać',
  page: '',

  // Pagination.jsx
  prev_page: 'Poprzednia strona',
  next_page: 'Następna strona',
  prev_5: 'Poprzednie 5 stron',
  next_5: 'Następne 5 stron',
  prev_3: 'Poprzednie 3 strony',
  next_3: 'Następne 3 strony'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-pagination@1.16.2@rc-pagination/es/locale/pl_PL.js
// module id = 1160
// module chunks = 0